import {
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Text,
  Box,
  AccordionItemProps,
} from '@chakra-ui/react';
import { isNil } from 'lodash';
import { FC, ReactNode, useMemo } from 'react';

import { useLibraryFilters } from '@/components/ui/features/library/LibraryFilter/LibraryFilter.hooks';
import { LibraryFilter } from '@/enums/LibraryFilter';

interface IFilterItemProps extends AccordionItemProps {
  parameter: LibraryFilter;
  children: ReactNode;
}

export const FilterItem: FC<IFilterItemProps> = ({ title, parameter, children }) => {
  const { filters } = useLibraryFilters();

  const isActive = useMemo(() => {
    return !isNil(filters[parameter]);
  }, [parameter, filters]);

  return (
    <AccordionItem>
      <AccordionButton pt="6" pb="8" px={0} color={isActive ? 'violet.500' : ''}>
        <Box flex="1" textAlign="left" fontWeight="bold">
          <Text textStyle="grotesk2XL">{title}</Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>

      <AccordionPanel pb={4} px={0}>
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
};
